export default __webpack_public_path__ + "static/media/team-background.6838ee21.png";